

import "@hotwired/turbo-rails"
import "trix"
import "@rails/actiontext"


// Tom Select
import TomSelect from 'tom-select/popular';
document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".tom-select").forEach(function (element) {
    new TomSelect(element);
  });
});

// Color Picker
import Picker from 'vanilla-picker';
document.addEventListener("turbo:load", () => {
  document.querySelectorAll('.color-picker').forEach(function (e) {
    let indicator = e.querySelector('i');
    let picker = new Picker({
      parent: e,
      popup: 'left',
      alpha: false,
      color: e.querySelector('input').value,
      onDone: function (color) {
        indicator.style.backgroundColor = color.hex;
        e.querySelector('input').value = color.hex.substring(1, 7);
      }
    });
  })
})

document.addEventListener("turbo:load", () => {
  let cardElement = document.querySelector("#card-element")

  if (cardElement !== null) { setupStripe() }

  // Handle users with existing card who would like to use a new one
  let newCard = document.querySelector("#use-new-card")
  if (newCard !== null) {
    newCard.addEventListener("click", (event) => {
      event.preventDefault()
      document.querySelector("#payment-form").classList.remove("d-none")
      document.querySelector("#existing-card").classList.add("d-none")
    })
  }
})

function setupStripe() {
  const stripe_key = document.querySelector("meta[name='stripe-key']").getAttribute("content")
  const stripe = Stripe(stripe_key)

  const elements = stripe.elements()
  const card = elements.create('card')
  card.mount('#card-element')

  var displayError = document.getElementById('card-errors')

  card.addEventListener('change', (event) => {
    if (event.error) {
      displayError.textContent = event.error.message
    } else {
      displayError.textContent = ''
    }
  })

  const form = document.querySelector("#payment-form")
  let paymentIntentId = form.dataset.paymentIntent
  let setupIntentId = form.dataset.setupIntent

  if (paymentIntentId) {
    if (form.dataset.status == "requires_action") {
      stripe.confirmCardPayment(paymentIntentId, { setup_future_usage: 'off_session' }).then((result) => {
        if (result.error) {
          displayError.textContent = result.error.message
          form.querySelector("#card-details").classList.remove("d-none")
        } else {
          form.submit()
        }
      })
    }
  }

  form.addEventListener('submit', (event) => {
    // Saved payment method selected: no tokenization needed — the server's
    // params[:payment_method_id] branch handles it. Without this, the empty
    // hidden card Element fails createPaymentMethod and Subscribe dead-ends.
    const savedMethod = form.querySelector('input[name*="payment_method_id"]:checked')
    if (savedMethod && savedMethod.value !== 'new') return

    event.preventDefault()

    // Disable the submit button during async tokenization — a double-click
    // would otherwise tokenize and submit twice (double charge attempt).
    const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]')
    if (submitBtn) submitBtn.disabled = true
    const reenable = () => { if (submitBtn) submitBtn.disabled = false }

    let name = form.querySelector("#name_on_card").value
    let data = {
      payment_method_data: {
        card: card,
        billing_details: {
          name: name,
        }
      }
    }

    // Complete a payment intent
    if (paymentIntentId) {
      stripe.confirmCardPayment(paymentIntentId, {
        payment_method: data.payment_method_data,
        setup_future_usage: 'off_session',
        save_payment_method: true,
      }).then((result) => {
        if (result.error) {
          displayError.textContent = result.error.message
          form.querySelector("#card-details").classList.remove("d-none")
        } else {
          form.submit()
        }
      })

      // Updating a card or subscribing with a trial (using a SetupIntent)
    } else if (setupIntentId) {
      stripe.confirmCardSetup(setupIntentId, {
        payment_method: data.payment_method_data
      }).then((result) => {
        if (result.error) {
          displayError.textContent = result.error.message
          reenable()
        } else {
          console.log(result);
          addHiddenField(form, "registration[card_token]", result.setupIntent.payment_method)
          form.submit()
        }
      })

    } else {
      // Subscribing with no trial
      data.payment_method_data.type = 'card'
      stripe.createPaymentMethod(data.payment_method_data).then((result) => {
        if (result.error) {
          displayError.textContent = result.error.message
          reenable()
        } else {
          addHiddenField(form, "registration[card_token]", result.paymentMethod.id)
          form.submit()
        }
      })
    }
  })
}

function addHiddenField(form, name, value) {
  let input = document.createElement("input")
  input.setAttribute("type", "hidden")
  input.setAttribute("name", name)
  input.setAttribute("value", value)
  form.appendChild(input)
}


// For editing photos
addEventListener('turbo:load', (event) => {
  const editImage = document.querySelector('#edit-image');
  const editImageFile = document.querySelector('#edit-image-file');

  if (!editImage) return;

  // Initialize dragging state
  editImage.classList.add('dragging');
  editImage.classList.remove('dragging');

  // Keyboard activation — the drop zone is a role=button div (P2e a11y)
  editImage.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); editImageFile && editImageFile.click(); }
  });

  editImage.addEventListener('dragover', function () {
    editImage.classList.add('dragging');
  });

  editImage.addEventListener('dragleave', function () {
    editImage.classList.remove('dragging');
  });

  editImage.addEventListener('drop', function (e) {
    editImage.classList.remove('dragging', 'hasImage');

    if (e.dataTransfer && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = function (e) {
        editImage.style.backgroundImage = `url(${reader.result})`;
        editImage.classList.add('hasImage');
      }
    }
  });

  editImage.addEventListener('click', function (e) {
    editImageFile?.click();
  });

  window.addEventListener("dragover", function (e) {
    e.preventDefault();
  }, false);

  window.addEventListener("drop", function (e) {
    e.preventDefault();
  }, false);

  if (editImageFile) {
    editImageFile.addEventListener('change', function (e) {
      const input = e.target;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = function (e) {
          editImage.style.backgroundImage = `url(${reader.result})`;
          editImage.classList.add('hasImage');
        }
      }
    });
  }
})


import { config, library, dom } from '@fortawesome/fontawesome-svg-core'
config.mutateApproach = 'sync'
import {
  faBackspace,
  faBell,
  faBullhorn,
  faCalendar,
  faCalendarAlt,
  faCalendarPlus,
  faChartArea,
  faChartBar,
  faChartPie,
  faCheckCircle,
  faChild,
  faClipboardList,
  faClock,
  faComment,
  faCommentDots,
  faEdit,
  faEnvelopeOpen,
  faEye,
  faFileAlt,
  faFolder,
  faFolderOpen,
  faHandPointer,
  faHandshake,
  faHeart,
  faInbox,
  faKey,
  faLock,
  faLink,
  faMapMarkerAlt,
  faMarker,
  faMask,
  faNewspaper,
  faPaperPlane,
  faPen,
  faPlus,
  faQuestionCircle,
  faRetweet,
  faRocket,
  faSearch,
  faShoppingCart,
  faSlidersH,
  faSort,
  faSpinner,
  faTable,
  faTachometerAlt,
  faTimesCircle,
  faUser,
  faUserFriends,
  faUsers,
  faWindowMaximize
} from '@fortawesome/free-solid-svg-icons'
library.add(
  faBackspace, faBell, faBullhorn, faCalendar, faCalendarAlt, faCalendarPlus,
  faChartArea, faChartBar, faChartPie,
  faCheckCircle, faChild, faClipboardList, faClock, faComment, faCommentDots, faEdit,
  faEnvelopeOpen, faEye, faFileAlt, faFolder, faFolderOpen, faHandPointer, faHandshake,
  faHeart, faInbox, faKey, faLink, faLock, faMapMarkerAlt, faMarker, faMask, faNewspaper,
  faPaperPlane, faPen, faPlus, faQuestionCircle, faRetweet, faRocket, faSearch, faShoppingCart,
  faSlidersH, faSort, faSpinner, faTable, faTachometerAlt, faTimesCircle,
  faUser, faUserFriends, faUsers, faWindowMaximize
)
import "chartkick/chart.js"

dom.watch()

// Frameworks and libraries
require("@rails/activestorage").start()

import moment from "moment"
window.moment = moment; // Make moment globally available for vanilla-daterangepicker

document.addEventListener("turbo:load", () => {
  const editImageFile = document.querySelector("#edit-image-file");
  const enableJoin = document.querySelector("#enable-join");
  const managerForm = document.querySelector("#manager-form");
  const accountForm = document.querySelector("#account-form");

  if (editImageFile) {
    editImageFile.addEventListener("change", function () {
      if (managerForm) {
        document.querySelector("#manager-form").requestSubmit();
      } else if (accountForm) {
        document.querySelector("#account-form").requestSubmit();
      }
    });
  }

  if (enableJoin) {
    enableJoin.addEventListener("change", function () {
      document.querySelector("#account-form").requestSubmit();
    });
  }
})

// Application logic

import "./controllers"


Turbo.setConfirmMethod((message, element) => {

  let dialog = document.createElement('dialog')
  dialog.id = "turbo-confirm"
  // Dual-vocabulary (Bootstrap pages until P5 + civic pages): .btn variants are
  // aliased in both bundles; spacing/flex utilities carried in both spellings.
  dialog.className = "card w-full max-w-md rounded-xl p-0"
  dialog.innerHTML = `
          <form method="dialog">
            <div class="p-4">
              <h2 class="mb-2 text-lg font-semibold">Confirm</h2>
              <p class="confirm-message mb-0"></p>
            </div>
            <div class="d-flex flex justify-content-end justify-end gap-2 border-t border-ink/6 p-3">
              <button value="cancel" class="btn btn-secondary">Cancel</button>
              <button value="confirm" class="btn btn-primary">Confirm</button>
            </div>
          </form>
  `
  // textContent, not innerHTML — confirm strings interpolate user data
  // (e.g. the manager's email in send-preview confirms)
  dialog.querySelector('.confirm-message').textContent = message
  document.body.appendChild(dialog)
  dialog.showModal()

  return new Promise((resolve, reject) => {
    dialog.addEventListener("close", (e) => {
      dialog.remove()
      resolve(dialog.returnValue == "confirm")
    }, { once: true })
  })
})

import DateRangePicker from "./lib/vanilla-daterangepicker"

const datePickedEvent = new Event('datepicked');

document.addEventListener("turbo:load", () => {
  document.querySelectorAll('input.datetime').forEach(function (element) {
    new DateRangePicker(element, {
      "singleDatePicker": true,
      "timePicker": true,
      locale: {
        format: 'MMM Do[,] YYYY [@] h:mma Z'
      }
    });

    // Listen for when the picker is closed (after the value has been updated)
    element.addEventListener('hide.daterangepicker', function (e) {
      window.dispatchEvent(datePickedEvent);
    });
  });
});
